module.exports = __webpack_public_path__ + "static/media/report-task-icon.8a0d17df.svg";